import { GA_MEASUREMENT_ID } from '../config/site';

// Google Analytics loads only after explicit opt-in. Before that, no script is
// requested from Google and no cookie is written. Withdrawing consent removes
// the GA cookies and stops all further events.

let loaded = false;
let enabled = false;

function gtag() {
  window.dataLayer = window.dataLayer || [];
  // eslint-disable-next-line prefer-rest-params
  window.dataLayer.push(arguments);
}

export function enableAnalytics() {
  if (typeof window === 'undefined') return;
  enabled = true;
  window[`ga-disable-${GA_MEASUREMENT_ID}`] = false;
  if (!loaded) {
    window.gtag = gtag;
    gtag('consent', 'default', {
      ad_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied',
      analytics_storage: 'granted',
    });
    gtag('js', new Date());
    gtag('config', GA_MEASUREMENT_ID, {
      anonymize_ip: true,
      allow_google_signals: false,
      allow_ad_personalization_signals: false,
      send_page_view: false,
      cookie_expires: 60 * 60 * 24 * 390, // 13 months maximum (CNIL guidance)
    });
    const s = document.createElement('script');
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    document.head.appendChild(s);
    loaded = true;
  } else {
    gtag('consent', 'update', { analytics_storage: 'granted' });
  }
}

export function disableAnalytics() {
  if (typeof window === 'undefined') return;
  enabled = false;
  window[`ga-disable-${GA_MEASUREMENT_ID}`] = true;
  if (loaded) gtag('consent', 'update', { analytics_storage: 'denied' });
  // Remove any GA cookies already set, on this host and its parent domain.
  const host = window.location.hostname;
  const domains = ['', host, `.${host}`, `.${host.split('.').slice(-2).join('.')}`];
  document.cookie.split(';').forEach((c) => {
    const name = c.split('=')[0].trim();
    if (name === '_ga' || name.startsWith('_ga_') || name === '_gid' || name === '_gat') {
      domains.forEach((d) => {
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/${d ? `; domain=${d}` : ''}`;
      });
    }
  });
}

// Events never include names, emails, user IDs or file names.
const BLOCKED_KEYS = /email|name|uid|user|file|ip/i;

export function track(event, params = {}) {
  if (!enabled || !loaded || typeof window.gtag !== 'function') return;
  const safe = {};
  Object.entries(params).forEach(([k, v]) => {
    if (!BLOCKED_KEYS.test(k) && (typeof v === 'number' || typeof v === 'string' || typeof v === 'boolean')) safe[k] = v;
  });
  window.gtag('event', event, safe);
}

export function trackPageView(path) {
  track('page_view', { page_path: path, page_location: window.location.origin + path });
}
